import React from 'react';
import { useParams, Routes, Route, Navigate } from 'react-router-dom';
import usePageData from '~/helpers/use-page-data';
import FlexPage, { LayoutUsingData } from '~/pages/flex-page/flex-page';
import useLayoutContext from '~/contexts/layout';
import { assertDefined } from '~/helpers/data';
import { GeneralPageFromSlug } from '~/pages/general/general';
import { ImportedPage } from './page-loaders';
import { RouteAsPortalOrNot } from './portal-page-routes';
import Error404 from '~/pages/404/404';
export function HomePage() {
    const data = usePageData('pages/home', true);
    if (!data) {
        return null;
    }
    return React.createElement(FlexPageUsingItsOwnLayout, { data: data });
}
export function ErrataRoutes() {
    return (React.createElement(Routes, null,
        React.createElement(Route, { index: true, element: React.createElement(ImportedPage, { name: "errata-summary" }) }),
        React.createElement(Route, { path: "/form/", element: React.createElement(ImportedPage, { name: "errata-form" }) }),
        React.createElement(Route, { path: "/*", element: React.createElement(ImportedPage, { name: "errata-detail" }) })));
}
export function DetailsRoutes() {
    return (React.createElement(Routes, null,
        React.createElement(Route, { index: true, element: React.createElement(Navigate, { to: "/subjects", replace: true }) }),
        React.createElement(Route, { path: "/books/:title", element: React.createElement(ImportedPage, { name: "details" }) }),
        React.createElement(Route, { path: "/:title", element: React.createElement(RedirectToCanonicalDetailsPage, null) })));
}
export function OtherPageRoutes() {
    const dir = assertDefined(useParams().dir);
    const { '*': path } = useParams();
    if (['books', 'textbooks'].includes(dir)) {
        return path === '' ? React.createElement(Error404, null) : (React.createElement(Routes, null,
            React.createElement(Route, { path: "/:title", element: React.createElement(RedirectToCanonicalDetailsPage, null) })));
    }
    if (dir === 'general') {
        return React.createElement(Navigate, { to: `/${path}`, replace: true });
    }
    if (dir === 'home') {
        return React.createElement(Navigate, { to: "/", replace: true });
    }
    // Some pages have no page data in the CMS!
    if (isNoDataPage(dir)) {
        return React.createElement(ImportedPage, { name: dir });
    }
    return React.createElement(RouteAsPortalOrNot, null);
}
export function isNoDataPage(dir) {
    return [
        'adopters',
        'adoption',
        'blog',
        'campaign',
        'confirmation',
        'institutional-partnership-application',
        'interest',
        'renewal-form',
        'separatemap'
    ].includes(dir);
}
// There are a couple of pages whose names in the CMS don't match their osweb urls
const mismatch = {
    press: 'news',
    'edtech-partner-program': 'openstax-ally-technology-partner-program',
    foundation: 'supporters'
};
export function usePageDataFromRoute() {
    var _a;
    const { dir: name, '*': other } = useParams();
    const data = usePageData(`pages/${(_a = mismatch[name]) !== null && _a !== void 0 ? _a : name}`, true);
    const hasError = data && 'error' in data;
    return { name, data, hasError, other };
}
export function FlexPageUsingItsOwnLayout({ data }) {
    return (React.createElement(LayoutUsingData, { data: data },
        React.createElement(FlexPage, { data: data })));
}
export function NonFlexPageUsingDefaultLayout({ data }) {
    const { dir: name } = useParams();
    const { setLayoutParameters } = useLayoutContext();
    const isGeneral = Boolean(data === null || data === void 0 ? void 0 : data.body);
    setLayoutParameters();
    return isGeneral ? (React.createElement(GeneralPageFromSlug, { slug: `spike/${data === null || data === void 0 ? void 0 : data.meta.slug}` })) : (React.createElement(ImportedPage, { name: name }));
}
function RedirectToCanonicalDetailsPage() {
    const { title } = useParams();
    return React.createElement(Navigate, { to: `/details/books/${title}`, replace: true });
}
